import { render, staticRenderFns } from "./informacionpedido.vue?vue&type=template&id=10bca086"
import script from "./informacionpedido.vue?vue&type=script&lang=js"
export * from "./informacionpedido.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports